

import React, { useEffect, useState } from "react";
import { Box, Divider, Grid2, Typography } from "@mui/material";
import UploadedResourcesTable from "./UploadedResourcesTable";
import NewUploadMain from "./NewUploadMain";

const ResourceOnboardingMain = () => {
    const [showNewUpload, setShowNewUpload] = useState(false);

    const handleNewUpload = () => {
        setShowNewUpload(true);
    };

    const handleBackToTable = () => {
        setShowNewUpload(false);
    };

    return (
        <Grid2 container flexDirection={'column'} gap={1} sx={{px: 3, py: 2}}>
            {!showNewUpload ? (
                <UploadedResourcesTable onNewUpload={handleNewUpload} />
            ) : (
                <NewUploadMain onBack={handleBackToTable} />
            )}
        </Grid2>
    );
}

export default ResourceOnboardingMain;
